import { Module } from '../modules/module';
import { TypeModule } from '../../enums/type-module';
import { NameModule } from '../name-module';

export class ModuleCertificate extends Module {
    typeVision: number;
    selected: boolean;

    constructor(name: NameModule, icon: string, typeVision: number, eventId: string, order: number) {
        super(name, icon, TypeModule.CERTIFICATE, eventId, order, true, null, true)
        this.typeVision = typeVision;
        this.selected = true;
    }
}
